import { IconButton, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { MdDelete } from 'react-icons/md';

const AttachmentCard = ({ attachImage, index, setSelectedImages }) => {
    const [imgName, setImageName] = useState('');

    useEffect(() => {
        setImageName(attachImage?.name || '');
    }, [attachImage]);

    const handleRemove = useCallback(() => {
        const idRaw = attachImage?.media_id;

        if (idRaw == null) {
            setSelectedImages((prev) => (prev ?? []).filter((_, idx) => idx !== index));
            return;
        }

        setSelectedImages((prev) =>
            (prev ?? []).map((img, idx) => {
                if (idx !== index) return img;
                return { ...img, toDelete: true }; // flag
            })
        );
    }, [attachImage?.media_id, index, setSelectedImages, attachImage]);

    if (attachImage?.toDelete) return null;

    return (
        <div style={{ width: '200px' }}>
            <div
                style={{
                    position: 'relative',
                    border: 'solid 1px lightgray',
                    width: '200px',
                    height: '200px',
                    boxSizing: 'content-box',
                    overflow: 'hidden',
                }}
            >
                <img
                    src={attachImage?.url}
                    alt={attachImage?.name}
                    style={{ objectFit: 'contain' }}
                    width="200px"
                    height="200px"
                />

                <IconButton
                    onClick={handleRemove}
                    aria-label="close"
                    sx={{ position: 'absolute', right: 0, top: 0, padding: 0 }}
                    size="large"
                >
                    <div style={{ fontSize: '12px', margin: 0, color: '#000000', backgroundColor: '#ffffff' }}>
                        <MdDelete className="react-icon" />
                    </div>
                </IconButton>
            </div>

            <div>
                <TextField
                    fullWidth
                    margin="normal"
                    value={imgName}
                    onChange={(e) => setImageName(e.target.value)}
                    onBlur={(e) => {
                        const value = e.target.value;
                        setSelectedImages((prev) =>
                            (prev ?? []).map((img, idx) => {
                                if (idx === index) return { ...img, name: value, isSaved: false };
                                return img;
                            })
                        );
                    }}
                    type="text"
                    variant="outlined"
                    inputProps={{
                        style: { padding: '3px', border: '1.5px solid #000000', borderRadius: '5px' },
                    }}
                />
            </div>
        </div>
    );
};

export { AttachmentCard };
